var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.103 3.734l1.202 1.202a2.259 2.259 0 01-.012 3.194L9.809 18.614l-6.228 2.46a.5.5 0 01-.647-.652l2.49-6.19L15.908 3.745a2.259 2.259 0 013.194-.012zm.802 2.161l-.089-.1-1.573-1.572c-.383-.384-.947-.441-1.259-.13l-1.592 1.592 2.961 2.961 1.592-1.591c.286-.286.262-.784-.04-1.16zm-2.259 3.459l-2.96-2.962-7.794 7.793 2.96 2.96 7.794-7.791zM6.114 14.962l.07-.07 2.962 2.96-.074.074L4 20l2.114-5.038z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit24);
export default __webpack_public_path__ + "static/media/icon-edit-24.fe25b0a0.svg";
export { ForwardRef as ReactComponent };